import { getRequest } from './api'

export async function getActivityLogs(params = {}) {
  const q = new URLSearchParams()
  q.append('size', params.size || 50)
  q.append('index', params.index || 0)
  if (params.userName) q.append('userName', params.userName)
  if (params.from) q.append('from', params.from)
  if (params.to) q.append('to', params.to)
  if (params.contractID) q.append('contractID', params.contractID)
  return getRequest(`useractivitylog/get-list?${q.toString()}`)
}

export default getActivityLogs
